import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "./globals.css";
import App from "./App.tsx";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ToastContainer } from "react-toastify";
import KeyShortcutsWrapper from "./utils/keyShortcuts";
const queryClient = new QueryClient();

// Prevent scroll wheel from changing number input values globally
document.addEventListener(
  "wheel",
  (e) => {
    const el = document.activeElement as HTMLInputElement | null;
    if (el?.type === "number") {
      el.blur();
    }
  },
  { passive: true },
);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <KeyShortcutsWrapper>
          <ToastContainer />
          <App />
          <ReactQueryDevtools initialIsOpen={false} />
        </KeyShortcutsWrapper>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
